export default "__VITE_ASSET__fb9f5a0d__"